<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        <v-img :src="require('../assets/logo.png')" class="my-3" contain height="70"></v-img>
      </v-flex>
    </v-layout>
<!--    <v-layout row justify-center>-->
<!--      <v-flex xs6>-->
<!--        <v-card>-->
<!--          <v-toolbar dark color="primary">-->
<!--            <v-toolbar-title>{{$t('bid.machine_request_title')}}</v-toolbar-title>-->
<!--          </v-toolbar>-->
<!--          <v-card-text>-->
<!--            <p>{{$t('bid.machine_request_content_1')}}</p>-->
<!--            <p>{{$t('bid.machine_request_content_2')}}</p>-->
<!--            <p>{{$t('bid.machine_request_content_3')}}</p>-->
<!--            <p>{{$t('bid.machine_request_content_4')}}</p>-->
<!--            <p>{{$t('bid.machine_request_content_5')}}</p>-->
<!--            <p>{{$t('bid.machine_request_content_6')}}</p>-->
<!--            <p>{{$t('bid.machine_request_content_7')}}</p>-->
<!--            <p>-->
<!--              {{$t('bid.bid_price')}}:-->
<!--              <v-text-field-->
<!--                :loading="loading"-->
<!--                v-model="price"-->
<!--                :value="$store.state.userData.display_name"-->
<!--                prefix="$"-->
<!--              ></v-text-field>-->
<!--            </p>-->
<!--            <v-flex class="text-center">-->
<!--              <v-btn-->
<!--                color="primary"-->
<!--                type="submit"-->
<!--                :loading="loading"-->
<!--                @click="submit"-->
<!--              >{{$t('bid.submit')}}</v-btn>-->
<!--            </v-flex>-->
<!--          </v-card-text>-->
<!--        </v-card>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
  </v-container>
</template>
<script>
import userService from '@/services/user'

export default {

  props: {
  },

  data () {
    return {
      loading: false,
      price: null
    }
  },

  created () {
    this.price = this.$store.state.userData.bid_price
  },

  methods: {
    async submit () {
      this.loading = true
      try {
        let result = await userService.bid(this.price)
        this.$store.commit('SET_USER_DATA', result.data.data)
        this.price = result.data.data.bid_price
        this.$toasted.success(this.$t('bid.request_success')).goAway(7000)
      } catch (error) {
        this.$toasted.error(this.$t('error_message')).goAway(5000)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
